import { render } from "./AssessmentSearch.vue?vue&type=template&id=2c2fb953&scoped=true&ts=true"
import script from "./AssessmentSearch.vue?vue&type=script&lang=ts"
export * from "./AssessmentSearch.vue?vue&type=script&lang=ts"

import "./AssessmentSearch.vue?vue&type=style&index=0&id=2c2fb953&scoped=true&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c2fb953"]])

export default __exports__